function setBtnPageTop(){
	if($('.wrap')[0].getAttribute('data-page') == 'service__index'){
		var n = $(window).height()*1.2;
	}else{
		var n = 500;
	}
	$(window).on('scroll', function(){
		var top = $(window).scrollTop();

		if(top > n){
			$('.btn--pagetop').addClass('is--visible');
		}else if(top <= n){
			$('.btn--pagetop').removeClass('is--visible');
		}
	});

	$(document).on('click', '.btn--pagetop',function(e){
		e.preventDefault();
		$( 'html,body' ).animate( { scrollTop: 0 }, 'swing' );
	});
}

module.exports = setBtnPageTop;



// WEBPACK FOOTER //
// ./es2015/module/_btn_pagetop.js